import {
  BulkAdapterInteface,
  BulkUpdateResponse,
  BulkInput,
  ListBulkOperationsInput,
} from 'src/adapter/BulkAdapterInterface';
import {
  BulkOperationGetAttributes,
  BulkOperationModel,
} from 'src/models/BulkOperationModel';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';

export class BulkApiClass {
  adapter: BulkAdapterInteface;
  constructor(adapter: BulkAdapterInteface) {
    this.adapter = adapter;
  }
  async bulkUpdateAccountsDryRun(
    input: BulkInput
  ): Promise<BulkUpdateResponse> {
    try {
      const Bulk = await this.adapter.bulkUpdateAccountsDryRun(input);
      return Bulk;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async bulkUpdateAccounts(input: BulkInput): Promise<BulkUpdateResponse> {
    try {
      const Bulk = await this.adapter.bulkUpdateAccounts(input);
      return Bulk;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async bulkUpdateResourcesDryRun(
    input: BulkInput
  ): Promise<BulkUpdateResponse> {
    try {
      const Bulk = await this.adapter.bulkUpdateResourcesDryRun(input);
      return Bulk;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async bulkUpdateResources(input: BulkInput): Promise<BulkUpdateResponse> {
    try {
      const Bulk = await this.adapter.bulkUpdateResources(input);
      return Bulk;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async downloadAccounts(): Promise<boolean> {
    try {
      const res = await this.adapter.downloadAccounts();
      return res;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async downloadResources(): Promise<boolean> {
    try {
      const res = await this.adapter.downloadResources();
      return res;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async listBulkOperations(
    conditions?: ListBulkOperationsInput
  ): Promise<{ total: number; data: BulkOperationGetAttributes[] }> {
    try {
      const res = await this.adapter.listBulkOperations(conditions);
      return {
        total: res.total,
        data: res.data.map(
          (bulkOperation: BulkOperationGetAttributes) =>
            new BulkOperationModel(bulkOperation)
        ),
      };
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
